import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ROUTES } from './api-routes';
import { DEFAULT_JSON_HEADERS } from './headers.config';
import { BaseLocation, Location, LocationConsumptionData, LocationDataPDR, LocationDataPOD } from '../interfaces/location';
import { ElectricityInvoice, GasInvoice } from '../interfaces/invoice-interfaces';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  constructor(private http: HttpClient) { }

  getLocations(): Observable<any> {
    return this.http.get<Location[]>(
      API_ROUTES.LOCATION.ALL
    );
  }

  getLocationLatestElectricityInvoices(): Observable<any> {
    return this.http.get<ElectricityInvoice[]>(
      API_ROUTES.LOCATION.ELECTRECITY_INVOICES
    );
  }

  getLocationLatestGasInvoices(): Observable<any> {
    return this.http.get<GasInvoice[]>(
      API_ROUTES.LOCATION.GAS_INVOICES
    );
  }

  getLocationsConsumption(): Observable<LocationConsumptionData[]> {
    return this.http.get<LocationConsumptionData[]>(
      API_ROUTES.LOCATION.CONSUMPTION
    );
  }

  createLocation(locationData: BaseLocation): Observable<any> {
    const payload = JSON.stringify(locationData);

    return this.http.post<Location>(
      `${API_ROUTES.LOCATION.CREATE}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  createLocationPOD(locationData: LocationDataPOD): Observable<any> {
    const payload = JSON.stringify(locationData);

    return this.http.post<Location>(
      `${API_ROUTES.LOCATION.POD}/${locationData.location_id}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  createLocationPDR(locationData: LocationDataPDR): Observable<any> {
    const payload = JSON.stringify(locationData);

    return this.http.post<Location>(
      `${API_ROUTES.LOCATION.PDR}/${locationData.location_id}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  updateLocation(locationData: BaseLocation): Observable<any> {
    const payload = JSON.stringify(locationData);

    return this.http.post<BaseLocation>(
      `${API_ROUTES.LOCATION.DEFAULT}/${locationData.id}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  updateLocationPOD(locationData: LocationDataPOD): Observable<any> {
    const payload = JSON.stringify(locationData);

    return this.http.post<LocationDataPOD>(
      `${API_ROUTES.LOCATION.POD}/${locationData.id}/update`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  updateLocationPDR(locationData: LocationDataPDR): Observable<any> {
    const payload = JSON.stringify(locationData);

    return this.http.post<LocationDataPDR>(
      `${API_ROUTES.LOCATION.PDR}/${locationData.id}/update`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  deleteLocation(location_id: string): Observable<any> {
    return this.http.delete<BaseLocation>(
      `${API_ROUTES.LOCATION.DEFAULT}/${location_id}`);
  }

  confirmLocation(location_id: string): Observable<any> {
    return this.http.post<BaseLocation>(
      `${API_ROUTES.LOCATION.DEFAULT}/${location_id}/confirm`,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  getLocationsByCompanyId(companyId: string): Observable<any> {
    return this.http.get<Location[]>(
      `${API_ROUTES.LOCATION.ALL}/${companyId}`
    );
  }

  createCompanyLocation(company_id: string, locationData: BaseLocation): Observable<any> {
    const payload = JSON.stringify(locationData);

    return this.http.post<Location>(
      `${API_ROUTES.LOCATION.CREATE}company/${company_id}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }
}
